import { render } from "./registerStatus.vue?vue&type=template&id=27532e04&scoped=true"
import script from "./registerStatus.vue?vue&type=script&lang=js"
export * from "./registerStatus.vue?vue&type=script&lang=js"

import "./registerStatus.vue?vue&type=style&index=0&id=27532e04&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27532e04"]])

export default __exports__